import './polyfills'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import i18n from './i18n'
import zhCN from './locales/zh-CN.ts'
import './index.css'

// Ensure i18n is initialized before rendering.
// On some old browsers, the i18n side-effect import may fail silently,
// causing t() to return raw keys instead of translations.
if (!i18n.isInitialized) {
  console.warn('i18n was not initialized, attempting fallback init...');
  try {
    i18n.init({
      resources: { 'zh-CN': { translation: zhCN } },
      lng: 'zh-CN',
      fallbackLng: 'zh-CN',
      interpolation: { escapeValue: false },
    });
  } catch (e) {
    console.error('i18n fallback init failed:', e);
  }
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
